import React, { useState } from "react";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const submit = (e) => {
    e.preventDefault();
    toast.success("Thanks — we'll be in touch shortly.");
    setForm({ name: "", email: "", message: "" });
  };
  return (
    <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-24" data-testid="contact-page">
      <p className="label-eyebrow">Contact</p>
      <h1 className="font-display text-5xl md:text-7xl font-black tracking-tighter leading-[0.9] mt-3">
        Let's talk.
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mt-16">
        <form onSubmit={submit} className="md:col-span-7 space-y-5">
          <Field label="Full name" value={form.name} onChange={(v)=>setForm({...form, name:v})} testid="contact-name" />
          <Field label="Email" type="email" value={form.email} onChange={(v)=>setForm({...form, email:v})} testid="contact-email" />
          <div>
            <label className="label-eyebrow block mb-2">Message</label>
            <textarea rows={5} className="input-sharp" value={form.message} onChange={(e)=>setForm({...form, message:e.target.value})} data-testid="contact-message" required />
          </div>
          <button className="btn-primary" data-testid="contact-submit" type="submit">Send message</button>
        </form>
        <aside className="md:col-span-5 space-y-6">
          <div className="border border-black p-6">
            <p className="label-eyebrow">Phone</p>
            <p className="font-display font-bold text-lg mt-2">+233 24 000 0000</p>
          </div>
          <div className="border border-black p-6">
            <p className="label-eyebrow">Email</p>
            <p className="font-display font-bold text-lg mt-2">info@twinstarsgh.com</p>
          </div>
          <div className="border border-black p-6">
            <p className="label-eyebrow">Location</p>
            <p className="font-display font-bold text-lg mt-2">Accra, Ghana</p>
          </div>
        </aside>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type="text", testid }) {
  return (
    <div>
      <label className="label-eyebrow block mb-2">{label}</label>
      <input type={type} className="input-sharp" value={value} onChange={(e)=>onChange(e.target.value)} data-testid={testid} required />
    </div>
  );
}
